'use client';

import { c as _c } from "react/compiler-runtime";
import { useBjInfoQuery } from '@module/queries/member/memberQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import { useParams, useRouter } from 'next/navigation';
import type React from 'react';
import { useEffect } from 'react';
import BannedprofileChannelContent from './BannedprofileChannelContent';
import ChannelSkeleton from './ChannelSkeleton';
import ChannelTabsContainer from './ChannelTabsContainer';
interface Props {
  children: React.ReactNode;
}
function ChannelBody(t0) {
  const $ = _c(17);
  const {
    children
  } = t0;
  const params = useParams();
  const channelId = params?.id ? decodeURIComponent(params.id) : "";
  const router = useRouter();
  const {
    pushModal,
    popModal
  } = useModalStore();
  let t1;
  if ($[0] !== channelId) {
    t1 = {
      userId: channelId,
      info: "media fanGrade adminBjNotice exchange checkEnter bookmark"
    };
    $[0] = channelId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: bjInfoData,
    isLoading,
    isError
  } = useBjInfoQuery(t1);
  const isBlockedService = !!bjInfoData?.bjInfo.blockService;
  let t2;
  if ($[2] !== isError || $[3] !== popModal || $[4] !== pushModal || $[5] !== router) {
    t2 = () => {
      if (isError) {
        pushModal({
          id: "ChannelBody",
          type: "CONFIRM_MODAL",
          options: {
            description: "\uCC44\uB110 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uB370 \uC2E4\uD328\uD558\uC600\uC2B5\uB2C8\uB2E4.",
            onClose: () => {
              router.push("/");
              popModal();
            }
          }
        });
      }
    };
    $[2] = isError;
    $[3] = popModal;
    $[4] = pushModal;
    $[5] = router;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isError) {
    t3 = [isError];
    $[7] = isError;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  if (isError) {
    return null;
  }
  if (isLoading) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ChannelSkeleton />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (isBlockedService) {
    let t4;
    if ($[10] !== bjInfoData) {
      t4 = <BannedprofileChannelContent bjInfo={bjInfoData} />;
      $[10] = bjInfoData;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  let t4;
  if ($[12] !== channelId) {
    t4 = <ChannelTabsContainer channelId={channelId} />;
    $[12] = channelId;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== children || $[15] !== t4) {
    t5 = <>{t4}{children}</>;
    $[14] = children;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export default ChannelBody;